import Icon from '@ant-design/icons';

const Heading2 = (props: any) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.66675 13.6667V2.43552H3.15988V7.48936H7.64592V2.43552H9.14307V13.6667H7.64592V8.74102H3.15988V13.6667H1.66675Z"
        fill="currentColor"
      />
      <path
        d="M10.0834 13.6269V12.5433L12.1252 10.4926C12.4118 10.2 12.6237 9.93734 12.761 9.7045C12.8983 9.46569 12.967 9.22091 12.967 8.97016C12.967 8.66568 12.8834 8.42986 12.7163 8.2627C12.5491 8.08956 12.3222 8.00299 12.0357 8.00299C11.7192 8.00299 11.4715 8.09553 11.2924 8.28061C11.1133 8.45971 11.0237 8.71046 11.0237 9.03285H9.9043C9.91027 8.61494 9.99982 8.25673 10.173 7.95822C10.3521 7.65374 10.6028 7.41791 10.9252 7.25075C11.2476 7.08358 11.6237 7 12.0536 7C12.4655 7 12.8237 7.07761 13.1282 7.23284C13.4327 7.38806 13.6685 7.60597 13.8357 7.88657C14.0028 8.16717 14.0864 8.5015 14.0864 8.88957C14.0864 9.28957 13.9819 9.68062 13.773 10.0627C13.57 10.4388 13.2416 10.8448 12.7879 11.2806L11.4267 12.615H14.167V13.6269H10.0834Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Heading2Icon = (props: any) => <Icon component={Heading2} {...props} />;
